const SALE_STATUS_CONFIG = {
  paid: { label: "Pago", variant: "success" },
  paid_externally: { label: "Pago externamente", variant: "success" },
  waiting_payment: { label: "Processando", variant: "info" },
  refund_pending: { label: "Reembolso pendente", variant: "warning" },
  refunded: { label: "Reembolsada", variant: "danger" },
  created: { label: "Criada", variant: "info" },
  refused: { label: "Recusada", variant: "danger" },
  canceled: { label: "Não pago", variant: "danger" },
  delayed: { label: "Em reconciliação", variant: "info" },
  chargedback: { label: "Chargeback", variant: "secondary" },
  pending_fraud_analysis: { label: "Mesa de análise", variant: "warning" }
};

export const SALE_RECURRENCE = {
  30: 'Mensal',
  90: 'Trimestral',
  180: 'Semestral',
  365: 'Anual',
};

export const SALE_TYPE = {
  TRANSACTION: 'Venda única',
  SUBSCRIPTION: 'Assinatura',
  CONTRACT: 'Contrato',
};

export const SALE_ROLE = {
  SELLER: "Vendedor",
  CO_SELLER: "Coprodutor",
  AFFILIATE: "Afiliado",
}

export function getSaleStatus(status) {
  if (!status) return "";

  const config = SALE_STATUS_CONFIG[status];

  return config ? config.label : "Status desconhecido";
}

export function getSaleStatusVariant(status) {
  if (!status) return "secondary";

  const config = SALE_STATUS_CONFIG[status];

  return config ? config.variant : "secondary";
}

export function getSaleStatusList() {
  return Object.entries(SALE_STATUS_CONFIG).map(([id, config]) => ({
    id,
    name: config.label,
  }));
}

export function getSaleRecurrence(recurrence) {
  if (!recurrence) return "Recorrência não informada";

  return SALE_RECURRENCE[recurrence] || recurrence;
}

export function getSaleType(type) {
  if (!type) return 'Tipo não informado';

  return SALE_TYPE[type] || 'Tipo desconhecido';
}

export function getSaleRole(role) {
  if (!role) return 'Função não informada';

  return SALE_ROLE[role] || 'Função desconhecida';
}
